<template>
  <header class="c-header">
    <a class="c-logo" href="http://www.spinneybeck.com">
      <img
        alt="Spinneybeck"
        src="../../assets/spin-logo.png"
        width="285"
        height="50"
      />
    </a>
    <nav class="c-nav">
      <a
        v-for="navItem in navItems"
        :key="navItem.text"
        :href="navItem.url"
        :class="getClasses(navItem.active)"
        >{{ navItem.text }}</a
      >
    </nav>
  </header>
</template>

<script>
export default {
  data() {
    return {
      navItems: [
        {
          text: 'Color Book',
          url: 'https://www.spinneybeck.com/colorbook/categories/',
        },
        {
          text: 'Upholstery Leather',
          url:
            'https://www.spinneybeck.com/upholstery-leather/categories/',
        },
        {
          text: 'Architectural Products',
          url: 'https://www.spinneybeck.com/architectural-products/',
        },
        {
          text: 'Design Tool',
          url: 'http://dt.spinneybeck.com/',
          active: true,
        },
        {
          text: 'Portfolio',
          url: 'https://www.spinneybeck.com/portfolio/categories/',
        },
        { text: 'About', url: 'https://www.spinneybeck.com/about' },
        {
          text: 'Shop',
          url: 'https://www.spinneybeck.com/shop/categories/',
        },
      ],
    };
  },
  methods: {
    getClasses(active) {
      console.log('active', active);
      return {
        'c-nav__item': true,
        'c-nav__item--test': true,
        'c-nav__item--active': active,
      };
    },
  },
};
</script>

<style scoped>
.c-header {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0 20px;
  margin: 9em auto 5em;
  max-width: 1310px;
  font-size: 10px;
}

.c-logo {
  margin-right: 30px;
}

.c-nav__item {
  font: normal 1.2em/1 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: #2f292a;
  text-transform: uppercase;
  display: inline-block;
  padding: 0 0.7em;
  margin: 1.5em 1.25em 0 0;
  background-color: #fff;
  text-decoration: none;
  line-height: 2.5em;
  white-space: nowrap;
}

.c-nav__item:last-of-type {
  margin-right: 0;
}

.c-nav__item:hover {
  background-color: #e6e7e8;
}

.c-nav__item--active {
  color: #050405;
  font-weight: bold;
}

@media (max-width: 31em) {
  .c-header {
    align-items: center;
    justify-content: center;
  }
}
@media (max-width: 50em) {
  .c-nav__tem {
    padding: 0em;
    padding-right: 0.8em;
  }
}
@media (max-width: 1310px) {
  .c-header {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// HeaderSpinneybeck.vue?a01e948c